import styled from 'styled-components';

type TabNavigationProps = {
  items: { content: JSX.Element }[];
  onClick: (index: number) => void;
  selectedIndex: number;
  size: 'medium' | 'small';
};

type TabListProps = {
  size: {
    fontSize: string;
    padding: string;
  };
};

type TabListItemProps = {
  selected: boolean;
};

const TabNavigation = ({
  items,
  size,
  selectedIndex,
  onClick,
}: TabNavigationProps) => {
  const handleClick = (index: number) => () => {
    onClick && onClick(index);
  };

  const sizes = {
    medium: {
      fontSize: '1rem',
      padding: '0.25rem 0.5rem',
    },
    small: {
      fontSize: '0.8rem',
      padding: '0.125rem 0.25rem',
    },
  };

  return (
    <nav>
      <TabList size={sizes[size]}>
        {items.map((item, index) => (
          <TabListItem
            key={index}
            selected={index === selectedIndex}
            onClick={handleClick(index)}
          >
            {item.content}
          </TabListItem>
        ))}
      </TabList>
    </nav>
  );
};

export default TabNavigation;

const TabList = styled.ul<TabListProps>`
  display: flex;
  list-style: none;
  font-size: ${({ size }) => size.fontSize};
  font-weight: 500;

  li {
    border: 0.0625rem solid #fc8e49;
    border-right-style: none;
    padding: ${({ size }) => size.padding};
    cursor: pointer;

    &:hover {
      color: #fc8e49;
    }

    &:first-child {
      border-bottom-left-radius: 0.25rem;
      border-top-left-radius: 0.25rem;
    }

    &:last-child {
      border-right-style: solid;
      border-bottom-right-radius: 0.25rem;
      border-top-right-radius: 0.25rem;
    }
  }
`;

const TabListItem = styled.li<TabListItemProps>`
  background-color: ${({ selected }) => (selected ? '#fff2eb' : 'none')};
  color: ${({ selected }) => (selected ? '#fc8e49' : '#7b7d8c')};
  font-weight: ${({ selected }) => (selected ? '500' : '400')};
`;
